import { Form, StringInput, SubmitButton } from 'modules/core/components/forms';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { clientSearchByNameValidationSchema } from '../validation';
import { clientActions } from '../store/clientStore';

interface ClientSearchByNameFormValues {
  firstName: string,
  lastName: string,
}

const ClientSearchByNameForm = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (values: ClientSearchByNameFormValues) => {
    setLoading(true);
    await clientActions.findClientsByName(values);
    setLoading(false);
  };

  return (
    <>
      <h4>Поиск клиента по имени и фамилии</h4>
      <Form
        initialValues={ {} }
        onSubmit={ handleSubmit }
        validationSchema={ clientSearchByNameValidationSchema }
        loading={ loading }
      >
        <Row>
          <Col md={ 5 }>
            <StringInput
              name='firstName'
              placeholder='Имя *'
            />
          </Col>
          <Col md={ 5 }>
            <StringInput
              name='lastName'
              placeholder='Фамилия *'
            />
          </Col>
          <Col md={ 2 }>
            <SubmitButton
              text='Найти'
            />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export { ClientSearchByNameForm };
